<template>
  <Toast/>
  <header>
    <div class="h-full bg-surface-50 dark:bg-surface-950">
      <div
          class="bg-surface-0 dark:bg-surface-900 py-4 px-12 border-b border-surface-200 dark:border-surface-800 flex items-center justify-between relative lg:static">
        <RouterLink to="/">
          <div class="flex items-center gap-4 py-2">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.84219 2.87829C5.69766 3.67858 4.6627 4.62478 3.76426 5.68992C7.4357 5.34906 12.1001 5.90564 17.5155 8.61335C23.2984 11.5047 27.955 11.6025 31.1958 10.9773C30.9017 10.087 30.5315 9.23135 30.093 8.41791C26.3832 8.80919 21.6272 8.29127 16.0845 5.51998C12.5648 3.76014 9.46221 3.03521 6.84219 2.87829ZM27.9259 5.33332C24.9962 2.06 20.7387 0 16 0C14.6084 0 13.2581 0.177686 11.9709 0.511584C13.7143 0.987269 15.5663 1.68319 17.5155 2.65781C21.5736 4.68682 25.0771 5.34013 27.9259 5.33332ZM31.8887 14.1025C27.9735 14.8756 22.567 14.7168 16.0845 11.4755C10.024 8.44527 5.20035 8.48343 1.94712 9.20639C1.7792 9.24367 1.61523 9.28287 1.45522 9.32367C1.0293 10.25 0.689308 11.2241 0.445362 12.2356C0.705909 12.166 0.975145 12.0998 1.25293 12.0381C5.19966 11.161 10.7761 11.1991 17.5155 14.5689C23.5761 17.5991 28.3997 17.561 31.6529 16.838C31.7644 16.8133 31.8742 16.7877 31.9822 16.7613C31.9941 16.509 32 16.2552 32 16C32 15.358 31.9622 14.7248 31.8887 14.1025ZM31.4598 20.1378C27.5826 20.8157 22.3336 20.5555 16.0845 17.431C10.024 14.4008 5.20035 14.439 1.94712 15.1619C1.225 15.3223 0.575392 15.5178 0.002344 15.7241C0.000781601 15.8158 0 15.9078 0 16C0 24.8366 7.16344 32 16 32C23.4057 32 29.6362 26.9687 31.4598 20.1378Z"
                  class="fill-surface-900 dark:fill-surface-0"
              />
            </svg>

            <span class="text-xl font-medium text-surface-900 dark:text-surface-0">ESTATEVAULT.IO</span>
          </div>
        </RouterLink>
        <a
            @click="toggleMenu"
            class="cursor-pointer block xl:hidden text-surface-700 dark:text-surface-100 mt-1"
        >
          <i class="pi pi-bars !text-2xl"/>
        </a>
        
        <div
            :class="[
        isMenuVisible ? 'flex' : 'hidden',
        'flex-col xl:flex-row j items-center grow justify-between absolute xl:static w-full bg-surface-0 dark:bg-surface-900 left-0 top-16 px-12 xl:px-0 z-50 shadow xl:shadow-none xl:flex']"
            @click="closeMenu"
        >

          <ul class="list-none p-0 py-4 xl:py-0 m-0 flex grow xl:items-center xl:justify-center text-surface-900 dark:text-surface-0 select-none flex-col xl:flex-row cursor-pointer">


            <li class="text-center xl:text-left"
            > 
              <span
                  class="flex justify-center xl:justify-start px-0 lg:px-8 py-2 hover:text-primary font-medium transition-colors duration-150">
                <RouterLink to="/">

                  <span>Home</span>
                </RouterLink>
              </span>
            </li>
            <li>
              <span
                  class="flex justify-center xl:justify-start px-0 lg:px-8 py-2 hover:text-primary font-medium transition-colors duration-150">
                <RouterLink to="/product">
                  <span>Product Information</span>
                </RouterLink>
              </span>
            </li>
            <li>
              <span
                  class="flex justify-center xl:justify-start px-0 lg:px-8 py-2 hover:text-primary font-medium transition-colors duration-150">
                <RouterLink to="/price">
                  <span>Pricing</span>
                </RouterLink>
              </span>
            </li>
            <li>
              <span
                  class="flex justify-center xl:justify-start px-0 lg:px-8 py-2 hover:text-primary font-medium transition-colors duration-150">
                <RouterLink to="/contact-us">
                <span>Contact Us</span>
                </RouterLink>
              </span>
            </li>
          </ul>


          <div class="flex flex-col xl:flex-row border-t xl:border-t-0 border-surface py-4 xl:py-0 mt-4 xl:mt-0 gap-4">
            <RouterLink to="/signup" class="w-full xl:w-auto">
              <Button severity="secondary" outlined label="Sign Up" class="w-full xl:w-auto min-w-[120px]"/>
            </RouterLink>
            <RouterLink to="/login" class="w-full xl:w-auto">
              <Button label="Login" class="w-full xl:w-auto min-w-[120px]"/>
            </RouterLink>
            <div class="w-full xl:w-auto">
              <Button outlined severity="secondary" @click="ToggleDarkMode">
                <template #icon>
                  <LucideIcon :name="iconForDarkModeToggle" />
                </template>
              </Button>
            </div>
          </div>


        </div>
      </div>
    </div>
  </header>
  <main>
    <router-view/>
  </main>
  <footer>
    <div class="px-6 py-20 md:px-12 lg:px-20 flex flex-col items-center gap-8">
      <div class="w-full">
        <div class="h-px w-full bg-surface-200 dark:bg-surface-700"/>
      </div>

      <div class="p-2">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.84219 2.87829C5.69766 3.67858 4.6627 4.62478 3.76426 5.68992C7.4357 5.34906 12.1001 5.90564 17.5155 8.61335C23.2984 11.5047 27.955 11.6025 31.1958 10.9773C30.9017 10.087 30.5315 9.23135 30.093 8.41791C26.3832 8.80919 21.6272 8.29127 16.0845 5.51998C12.5648 3.76014 9.46221 3.03521 6.84219 2.87829ZM27.9259 5.33332C24.9962 2.06 20.7387 0 16 0C14.6084 0 13.2581 0.177686 11.9709 0.511584C13.7143 0.987269 15.5663 1.68319 17.5155 2.65781C21.5736 4.68682 25.0771 5.34013 27.9259 5.33332ZM31.8887 14.1025C27.9735 14.8756 22.567 14.7168 16.0845 11.4755C10.024 8.44527 5.20035 8.48343 1.94712 9.20639C1.7792 9.24367 1.61523 9.28287 1.45522 9.32367C1.0293 10.25 0.689308 11.2241 0.445362 12.2356C0.705909 12.166 0.975145 12.0998 1.25293 12.0381C5.19966 11.161 10.7761 11.1991 17.5155 14.5689C23.5761 17.5991 28.3997 17.561 31.6529 16.838C31.7644 16.8133 31.8742 16.7877 31.9822 16.7613C31.9941 16.509 32 16.2552 32 16C32 15.358 31.9622 14.7248 31.8887 14.1025ZM31.4598 20.1378C27.5826 20.8157 22.3336 20.5555 16.0845 17.431C10.024 14.4008 5.20035 14.439 1.94712 15.1619C1.225 15.3223 0.575392 15.5178 0.002344 15.7241C0.000781601 15.8158 0 15.9078 0 16C0 24.8366 7.16344 32 16 32C23.4057 32 29.6362 26.9687 31.4598 20.1378Z"
              class="fill-surface-900 dark:fill-surface-0"
          />
        </svg>
      </div>

      <div class="flex flex-wrap justify-center items-center gap-y-4 gap-x-8 p-2">
        <RouterLink
            v-for="item in footerLinks"
            :key="item.path"
            :to="item.path"
            class="text-surface-700 hover:text-surface-900 dark:text-surface-300 dark:hover:text-surface-0 leading-tight transition-colors cursor-pointer"
        >
          {{ item.label }}
        </RouterLink>
      </div>

      <div class="flex flex-wrap items-center justify-center gap-4">
        <div
            class="text-sm leading-tight text-surface-500 hover:text-surface-900 dark:text-surface-300 dark:hover:text-surface-0 transition-colors cursor-pointer">
          <RouterLink to="terms-of-service">
            Terms of Service
          </RouterLink>
        </div>
        <div
            class="text-sm leading-tight text-surface-500 hover:text-surface-900 dark:text-surface-300 dark:hover:text-surface-0 transition-colors cursor-pointer">
          <RouterLink to="privacy-policy">
            Privacy Policy
          </RouterLink>
        </div>
        <div
            class="text-sm leading-tight text-surface-500 hover:text-surface-900 dark:text-surface-300 dark:hover:text-surface-0 transition-colors cursor-pointer">
          <RouterLink to="refund-policy">
            Refund Policy
          </RouterLink>
        </div>
      </div>
    </div>
  </footer>
</template>


<script setup>
import {computed, ref} from "vue";
import {useRouter} from "vue-router";
import LucideIcon from "@/components/LucideIconComponent.vue";

const router = useRouter();
const isMenuVisible = ref(false);
const darkMode = ref(false);

const iconForDarkModeToggle = computed(() => (darkMode.value ? 'Moon' : 'Sun'));

const toggleMenu = () => {
  isMenuVisible.value = !isMenuVisible.value;
};

const closeMenu = () => {
  // Only attempt to close if we're in mobile view
  if (window.innerWidth < 1280) { // 1024px is the 'xl' breakpoint in Tailwind by default
    isMenuVisible.value = false;
  }
};


const footerLinks = [
  {label: 'Home', path: '/'},
  {label: 'Product Information', path: '/product'},
  {label: 'Pricing', path: '/price'},
  {label: 'Contact Us', path: '/contact-us'}
];


const ToggleDarkMode = () => {
  if (localStorage.getItem('dark_mode') === 'true') {
    localStorage.setItem('dark_mode', 'false');
    document.documentElement.classList.remove('my-app-dark');
  } else {
    localStorage.setItem('dark_mode', 'true');
    document.documentElement.classList.add('my-app-dark');
  }

  SetDarkModeIcon();
}

const SetDarkModeIcon = () => {
  darkMode.value = document.documentElement.classList.contains('my-app-dark');
}

</script>
